<template>
  <section  v-if="shelf"
            class="section" >
    <h4 data-int="shelf-section" 
        class="title is-4">
      <router-link :to="{ name: 'FavoritesItem', 
                          params: {id: shelfId} }">
        {{ shelf.name }}
      </router-link>
    </h4>
    <template v-if="hasItems">
      <div  class="columns is-mobile" 
            :class="{ 'is-multiline': showMore }" >
        <div v-for="(item, index) in items"
            :key="index"
            class="column is-2-desktop is-3-tablet is-4-mobile">
          <card data-int="shelf-item" 
                :item="item" 
                @click="select(item)" />
        </div>
      </div>
      <div  :class="{ 'is-hidden-desktop': items.length < 7,
                    'is-hidden-tablet': items.length < 5,
                    'is-hidden-mobile': items.length < 4 }"
          data-int="favorites-more-less-link"
          @click="showMore = !showMore">
        <a v-if="showMore" class="is-pulled-right">{{ $t('showLess') }}</a>
        <a v-else class="is-pulled-right">{{ $t('showMore') }}</a>
      </div>
    </template>
    <div v-else>
      {{ $t('noItemsFound') }}
    </div>
  </section>
</template>

<script>
import http from '@/http';
import Card from '@/components/common/Card';
import { mapActions } from "vuex";

export default {
  components: {Card},
  props: {
    shelfId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showMore: false,
      shelf: null,
      items: []
    };
  },
  computed: {
    hasItems() {
      return this.items.length > 0;
    }
  },
  created() {
    this.fetchShelf();
    this.fetchShelfItems();
  },
  methods: {
    ...mapActions({
      resetBrowseState: 'browse/resetBrowseState'
    }),
    async fetchShelf() {
      try {
        const {data} = await http.get(`media-shelves/${this.shelfId}`);
        this.shelf = data;
      } catch (error) {
        console.log('error :>> ', error);
      }
    },
    async fetchShelfItems() {
      try {
        const {data} = await http.get(`media-shelves/${this.shelfId}/items`);
        this.items = data;
      } catch (error) {
        console.log('error :>> ', error);
      }
    },
    async select(item) {
      const path = (item.entityType === "productpage")
        ? `/product-page/${item.entityId}`
        : `/${item.mediaType}/${item.entityId}`
      await this.resetBrowseState()
      this.$router.push({ path })
    }
  }
};
</script>

<style scoped>
.section {
  padding: 0.5rem 1rem 1rem 1rem;
  height: auto;
  overflow: hidden;
  border-bottom: lightgray 1px solid;
}

.is-pulled-right {
  align-items: right;
}
</style>
